var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1369 10.624H56.2737V22.2136H64V14.4872C64 12.3534 62.2706 10.624 60.1369 10.624Z",
    fill: "#FFA436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1368 14.487L48.5473 29.9397H0V6.76064C0 4.62688 1.72942 2.89746 3.86318 2.89746H22.673C23.698 2.89746 24.6806 3.30438 25.4056 4.02937L32 10.6238H56.2736C58.4074 10.6238 60.1368 12.3532 60.1368 14.487Z",
    fill: "#FFBC2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2737 14.4873L48.5474 24.1453H60.1369V14.4873H56.2737Z",
    fill: "#473F87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2737 14.4873V33.8032L3.86328 18.3505V14.4873H56.2737Z",
    fill: "#7B3EB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86328 18.3506H41.3271V29.9401H3.86328V18.3506Z",
    fill: "#B472EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1369 18.3506L56.2737 22.2138V61.1031H60.1369C62.2706 61.1031 64 59.3737 64 57.2399V22.2138C64 20.08 62.2706 18.3506 60.1369 18.3506Z",
    fill: "#FFBC2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1368 18.3506V57.2399C60.1368 59.3737 58.4074 61.1031 56.2736 61.1031H3.86318C1.72942 61.1031 0 59.3737 0 57.2399V29.9401C0 27.8064 1.72942 26.0769 3.86318 26.0769H32L38.5944 19.4825C39.3194 18.7575 40.302 18.3506 41.327 18.3506H60.1368Z",
    fill: "#FFCF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.dcf9f1458d5d780cba5e73da499e4814.svg";
export { ForwardRef as ReactComponent };